/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartService } from '../../services/chart.service';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray,  } from '@angular/forms';
import { UtilsService } from '../../services/utils.service';
import { FilterResultService } from '../../services/filter-result/filter-result.service';




@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
})
export class FilterPanelComponent  implements OnInit {
 
  @Input() chart:any;
  @Input() id:any;

  @Output() resultsUpdated = new EventEmitter<any[]>(); 

  

  output: { [key: string]: string[] } = {};
  selectedOptions: { [dimension: string]: string[] } = {};
  dimensions: any=['Geo','Manager'];
  matrices: any = [];
  filteredResults = [];
  selectedChartLabels: any = [];
  filteredLabels: any;
  filterdDatasets: any;
  selectRange: string | null = null;
  selectfilterType: any;
  filteredMatrices: any[] = [];
  rangedmatrices:any[]=[];
  selectedMetrices:any[]=[];
  checkedMatrices: { [key: string]: boolean } = {};
  checkedLabels: { [key: string]: boolean } = {};
  minRangeValue: number = 0;
  maxRangeValue: number = 0;
  lowerValue: number = 0;
  upperValue: number = 0;
  matricRangeEnabled: boolean = false;
  trainerMode:boolean=false;
  minMaxMetrices:any=[];
  updatedMinMaxmetrices:any=[];
  filteredMinMaxMetrices:any=[];
  reset:boolean=false;

  selectedLabel: string | null = null;
 
  selectedLabels: string[] = [];
  dataSets:any[]=[];
  rangeForm: FormGroup;
  metricRangeForm:FormGroup;
  results:any;
  graphDatasets:any;
  resultIndex:any;


  constructor(private chartService:ChartService,public utilService:UtilsService,private fb: FormBuilder,private filterResultService:FilterResultService) { 
     this.rangeForm = new FormGroup({
          minValue: new FormControl('0', [Validators.required],),
          maxValue: new FormControl('1000', [Validators.required],),
        });
        this.metricRangeForm= new FormGroup({});
  }

  ngOnInit() {
    // this.initializeData();
    this.createFormControls();
  }

  ngOnChanges() {
    this.initializeData();
    this.reInit();
    this.createFormControls();
  }
  private initializeData() {
    if(!this.utilService.filterDataNotFound && this.utilService.filterDataLoaded){

    const graphData=this.filterResultService.getGraphData(this.id)
   
    this.results=this.filterResultService.getOriginalResults(this.id)
    this.resultIndex=graphData.resultIndex
    this.graphDatasets=graphData.graphDatasets
    if(this.graphDatasets.length!=0){
    this.dimensions = this.chartService.extractValuesAfterDot(this.graphDatasets['dimensions']);
    this.matrices = this.graphDatasets['metrics'];
    this.dataSets = this.chartService.createDynamicDatasets(this.matrices, this.results);
    this.filterData();
    this.setMinMax();
    this.minMaxMetrices = this.getMinMaxMetrics();
    this.updatedMinMaxmetrices = this.minMaxMetrices;
    }
  }
  }

  private reInit() {
    const filterResultData = this.filterResultService.getFilterData(this.id)
    if (filterResultData) {
      this.restoreFilterData(filterResultData.data);
    } else {
      this.resetFilterData();
    }
    
  }

  private restoreFilterData(filterResultData: any) {
    this.filteredLabels = filterResultData.filteredLabels || [];
    this.filteredResults = filterResultData.filteredResults || [];
    this.selectedChartLabels = filterResultData.selectedChartLabels || [];
    this.selectedOptions = filterResultData.selectOptions || {};
    this.checkedLabels = filterResultData.checkedLabels || {};
    this.updatedMinMaxmetrices = filterResultData.updatedMinMaxmetrices ||{};
    this.checkedMatrices=filterResultData.checkedMatrices||{};
    this.filteredMatrices=filterResultData.filteredMatrices||[];
  }

  private resetFilterData() {
    this.filteredLabels = [];
    this.filteredResults = [];
    this.selectedChartLabels = [];
    this.selectedOptions = {};
    this.checkedLabels = {};
    this.checkedMatrices={};
    this.filteredMatrices=[];
    this.updatedMinMaxmetrices = this.minMaxMetrices;
  }
  
  

  getOptions(dimension: string): string[] {
   
   
    return this.output[dimension].sort((a, b) => {
      
      const dateA = new Date(a);
      const dateB = new Date(b);
  
      
      if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
        
        return dateA.getTime() - dateB.getTime();
      } else if (!isNaN(dateA.getTime())) {
        
        return -1;
      } else if (!isNaN(dateB.getTime())) {
        
        return 1;
      } else {
        
        return a.localeCompare(b);
      }
    })||[];
   
  }
  get metrics(): FormArray {
    return this.metricRangeForm.get('metrics') as FormArray;
  }
  getMetricValue(i: number): any {
    return (this.metrics.controls[i] as FormGroup).get('metric')?.value;
  }
  createFormControls() {
    this.metricRangeForm = this.fb.group({
      metrics: this.fb.array([]), 
    });
    this.updatedMinMaxmetrices.forEach((item: { metric: any; min: any; max: any; }) => {
      this.metrics.push(
        this.fb.group({
          metric: new FormControl(item.metric), // Add metric name (read-only)
          min: new FormControl(item.min), // Add min value
          max: new FormControl(item.max), // Add max value
        })
      );
    });
  }
  filterDatasets() {
    this.filterResults();
    this.resultsUpdated.emit(this.filteredResults,);
       this.filteredLabels=this.chartService.generateDynamicLabels(this.filteredResults, this.chartService.extractValuesAfterDot(this.selectedChartLabels.length==0?this.dimensions:this.selectedChartLabels));
       this.filterdDatasets=this.chartService.createDynamicDatasets(this.filteredMatrices.length!==0?this.filteredMatrices:this.matrices, this.filteredResults.length==0?this.results:this.filteredResults);
      if(this.chart){
       this.chartService.updateChart(this.filteredLabels,this.filterdDatasets,this.chart,);
      }
      const data={
        resultIndex:this.resultIndex,
        filterResults:this.filteredResults,
        filteredLabels:this.filteredLabels,
        filteredDatasets:this.filterdDatasets,
        filteredMatrices:this.filteredMatrices,
        checkedMatrices:this.checkedMatrices,
        checkedLabels:this.checkedLabels,
        selectedChartLabels:this.selectedChartLabels,
        selectOptions:this.selectedOptions,
        updatedMinMaxmetrices:this.updatedMinMaxmetrices}
       this.chartService.updateFilterData(data)

        this.utilService.saveFilterData(this.resultIndex,data)
      }
    

  filterResults() {
    this.filteredResults = this.results.filter((result: { [x: string]: string; }) => {
      return Object.keys(this.selectedOptions).every(key => {

        if (this.selectedOptions[key] && this.selectedOptions[key].length > 0) {
          if (!this.selectedChartLabels.includes(key)) {
            this.selectedChartLabels.push(key)
          }
          return this.selectedOptions[key].includes(result[key]);
        }
        return true;
      });
    });
    this.filteredResults=this.filterResults1()
    if (this.matricRangeEnabled) {
      const metrices = this.selectedMetrices.length == 0 ? this.matrices : this.selectedMetrices
      this.filteredResults = this.filteredResults.filter((entry: { [x: string]: any }) => {
        return metrices.some((key: string | number) => {
          const value = entry[key];
          const parsedValue = parseFloat(value);
          
          
          if(!isNaN(parsedValue) && parsedValue >= this.lowerValue && parsedValue <= this.upperValue){
            if (!this.rangedmatrices.includes(key)) {
              this.rangedmatrices.push(key)
            }
          }
          return !isNaN(parsedValue) && parsedValue >= this.lowerValue && parsedValue <= this.upperValue;
        });
      });

    }
    
    
    this.updateChartLabels()
  }
  updateChartLabels() {
    this.selectedChartLabels = [];
    Object.keys(this.selectedOptions).every(key => {

      if (this.selectedOptions[key] && this.selectedOptions[key].length > 0) {
        if (!this.selectedChartLabels.includes(key)) {
          this.selectedChartLabels.push(key)
        }

      }
      return true;
    });
  }

  selectedRange(item: any, option: any) {
    this.selectRange = item
    this.selectfilterType = option
    if (this.selectedLabel === this.selectRange) {
      this.selectedLabel = null;
      this.selectRange = "0-20"
    } else {
      this.selectedLabel = this.selectRange;
    }
  }
  selectedMatrices(selectedMatrice: any, checked: boolean) {
 
    if (checked) {

      if (!this.filteredMatrices.includes(selectedMatrice)) {
        this.filteredMatrices.push(selectedMatrice);
      }
     
    } else {

      this.filteredMatrices = this.filteredMatrices.filter(item => item !== selectedMatrice);
    }
    
    this.checkedMatrices[selectedMatrice] = checked;
    this.filterDatasets()

  }

  onRangeChange(event: CustomEvent) {
    const { lower, upper } = event.detail.value;
    this.lowerValue = lower;
    this.upperValue = upper;
    this.filterDatasets()
  }
 
  resetDatasets() {
    this.dimensions = this.chartService.extractValuesAfterDot(this.graphDatasets['dimensions'])
    this.matrices = this.graphDatasets['metrics'];
    this.dataSets=this.chartService.createDynamicDatasets(this.matrices,this.results);
    this.minMaxMetrices=this.getMinMaxMetrics()
    // this.chartService.filterResultData=[];
    this.reset=true
    this.selectedOptions = {}
    this.filteredMatrices = [];
    this.setMinMax();
    this.updatedMinMaxmetrices=this.minMaxMetrices
    this.createFormControls();
    this.matricRangeEnabled = false;
    this.matrices.forEach((item: string | number) => {
      this.checkedMatrices[item] = false;
    })
    this.checkedLabels = {}
    
      this.filterDatasets();
      this.resultsUpdated.emit(this.results);
    

  }
  getMinValue() {
    this.minRangeValue = this.rangeForm.value.minValue;
    this.lowerValue = this.rangeForm.value.minValue;
    
  }
  getMaxValue() {
    this.maxRangeValue = this.rangeForm.value.maxValue;
    this.upperValue = this.rangeForm.value.maxValue;
    
  }
  selectedOption(option: string, dimension: string, checked: boolean): void {
   
    if (!this.selectedOptions[dimension]) {
      this.selectedOptions[dimension] = [];
    }

    if (checked) {

      if (!this.selectedOptions[dimension].includes(option)) {
        this.selectedOptions[dimension].push(option);
      }
    } else {

      const index = this.selectedOptions[dimension].indexOf(option);
      if (index > -1) {
        this.selectedOptions[dimension].splice(index, 1);
      }
    }
    this.checkedLabels[option] = checked;
    this.filterDatasets()
  }

 closeFilterMenu(){
  this.utilService.filterMenuOpen=false;
  this.utilService.updateResults()
 }
 filterData() {
  
  const sets: { [key: string]: Set<string> } = {};
  this.dimensions.forEach((dimension: any) => {
    sets[dimension] = new Set<string>();
  });
  this.results.forEach((entry: { [x: string]: string; }) => {
    this.dimensions.forEach((dimension: any) => {
      if (entry[dimension]) {
        sets[dimension].add(entry[dimension]);
      }
    });
  });
  this.dimensions.forEach((dimension: string | number) => {
    this.output[dimension] = Array.from(sets[dimension]);
  }); 
}
setMinMax(){
  const {numberValues}=this.chartService.separateData(this.results);
  const numericValues = numberValues
  .map((item) => typeof item === 'string' ? parseFloat(item) : item) 
  .filter((item) => !isNaN(item) && typeof item === 'number'); 

if (numericValues.length === 0) {
  
  this.rangeForm.controls['minValue'].setValue(0)
  this.rangeForm.controls['maxValue'].setValue(0)
}

 

const min = Math.min(...numericValues );
const max = Math.max(...numericValues);
this.rangeForm.controls['minValue'].setValue(min)
this.rangeForm.controls['maxValue'].setValue(max)
this.minRangeValue=this.lowerValue=min;
this.maxRangeValue=this.upperValue= max;

}
getMinMaxMetrics() {
  
  const matrices = this.matrices;

  
  const result: { metric: any; min: number; max: number; }[] = [];

  
  matrices.forEach((metric: string) => {
      
      const values = this.results.map((item: { [x: string]: string; }) => parseFloat(item[metric]));

      
      const min = Math.min(...values);
      const max = Math.max(...values);

      
      result.push({
          metric,
          min,
          max,
      });
  });

  return result;
}

getMatricMinValue(metric: string, event: any,index:any): void {
  const minValue = event.detail.value;
  const metricGroup = this.metrics.controls[index] as FormGroup;
  const maxValue=metricGroup.get('max')?.value;
  this.metricRangeForm.get(metric)?.get('min')?.setValue(minValue);
 
  this.metricRangeForm.get(metric)?.get('max')?.setValue(maxValue);
  if(this.filteredMinMaxMetrices.length==0){
   this.filteredMinMaxMetrices.push({
     metric,
     minValue,
     maxValue,
 });
  }
  else{
  this.filteredMinMaxMetrices.filter((item: any)=>{
   if(item.metric===metric){
     item.minValue=minValue
     item.maxValue=maxValue
   }
   else{
     this.filteredMinMaxMetrices.push({
       metric,
       minValue,
       maxValue,
   });
   }
 })
  } 
  this.modifyArray() 
  this.filterDatasets()
 
}

getMatricMaxValue(metric: string, event: any,index:any): void {
  const maxValue = event.detail.value;
  const metricGroup = this.metrics.controls[index] as FormGroup;
  const minValue=metricGroup.get('min')?.value;
  
 this.metricRangeForm.get(metric)?.get('max')?.setValue(maxValue);
 if(this.filteredMinMaxMetrices.length==0){
  this.filteredMinMaxMetrices.push({
    metric,
    minValue,
    maxValue,
});
 }
 else{
 this.filteredMinMaxMetrices.filter((item: any)=>{
  if(item.metric===metric){
    item.minValue=minValue
    item.maxValue=maxValue
  }
  else{
    this.filteredMinMaxMetrices.push({
      metric,
      minValue,
      maxValue,
  });
  }
})
 } 
 this. modifyArray() 
this.filterDatasets()


}
filterResults1() {
  return this.filteredResults.filter((result: { [x: string]: string; }) => {
    return this.filteredMinMaxMetrices.every((filter: { metric: any; minValue: string; maxValue: string; }) => {
      const metric = filter.metric;
      const minValue = parseFloat(filter.minValue);
      const maxValue = parseFloat(filter.maxValue);  
      const resultValue = parseFloat(result[metric]);
      return resultValue >= minValue && resultValue <= maxValue;
    });
  });
}

  modifyArray() {
    
    this.filteredMinMaxMetrices.forEach((item2: { metric: any; minValue: any; maxValue: any; }) => {
      
        const index = this.updatedMinMaxmetrices.findIndex((item1: { metric: any; }) => item1.metric === item2.metric);

     
        if (index !== -1) {
          this.updatedMinMaxmetrices[index].min = item2.minValue;
          this.updatedMinMaxmetrices[index].max = item2.maxValue;
        }
    });

}
}

  



